export default __webpack_public_path__ + "static/media/grafema_capitolio_10.77be0758.jpg";